/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ToggleButtonOptionModel} from './toggle-button-option.model';
import {UntypedFormBuilder, UntypedFormControl} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToggleButtonComponent implements OnInit, OnDestroy {

    /** Output variable for selected option**/
    @Output() selectedOption = new EventEmitter<ToggleButtonOptionModel>();
    /** Input variable for options **/
    @Input() options: ToggleButtonOptionModel[] = [{code: 'Code', description: 'Description'}];
    /** Input variable to reset the form **/
    @Input() resetSelection: EventEmitter<boolean> = new EventEmitter<boolean>();
    /** Input for initial selection **/
    @Input() preSelectedOption: ToggleButtonOptionModel;

    public toggleButtonsForm = this.formBuilder.group({
        option: new UntypedFormControl()
    });

    private subscriptions = new Subscription();


    constructor(private formBuilder: UntypedFormBuilder) {
    }

    ngOnInit(): void {
        this.selectOption();
        this.resetForm();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /** Emits the selected option on form value change**/
    selectOption(): void {
        this.subscriptions.add(
                this.toggleButtonsForm.get('option').valueChanges.subscribe((value) => {
                    this.selectedOption.emit(value);
                })
        );
    }

    /** Resets the form selection **/
    resetForm(): void {
        this.subscriptions.add(
                this.resetSelection.subscribe(() => {
                    this.toggleButtonsForm.reset();
                }));
    }

}
